module.exports = __webpack_public_path__ + "img/color-on-white@2x.b935d0dd.png";